/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Form, Input, Button, message, Select, Row, Col, Modal, Popconfirm } from "antd";
import { getFirestore, setDoc, doc, getDocs, collection } from "firebase/firestore";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import {
  validateFullName,
  validatePhone,
  validatePassword,
} from "./validations";
import { roles, genders, decrypt, APP_VERSION } from "../../utils";
import { logUserAction } from "../../logs";

const { Option } = Select;

export const AddUser = ({ isModalOpen, setIsModalOpen, updateData }) => {
  // firestore imports
  const db = getFirestore();
  const auth = getAuth();

  const [form] = Form.useForm();

  // handle pop confirm
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [isCourier, setIsCourier] = useState(false);
  const [data, setData] = useState();

  const handleRoleChange = value => {
    if (value === 'Courier') {
      setIsCourier(true);
    } else {
      setIsCourier(false);
    }
  };
  /**
   * register event
   * @param {Object} values
   * contains the submited data in the registration process into the database
   */
  const handleSignUp = async (values) => {
    try {
      // app credentials
      const sessionEmail = await decrypt(localStorage.getItem("id"));
      const sessionPassword = await decrypt(localStorage.getItem("key"));
      // create new user
      const newUser = await createUserWithEmailAndPassword(auth, values.email, values.password);
      // store new user data
      console.log("newUser", newUser)
      await setDoc(doc(db, "user", newUser.user.uid), {
        name: values.name,
        surname: values.surname,
        email: values.email.toLowerCase(),
        phone: values.phone,
        password: values.password,
        role: values.role,
        courier: values.courierAssociation || "NO APLICA",
        status: true,
      })
      // reset form
      form.resetFields();
      // log in with the current user
      await signInWithEmailAndPassword(auth, sessionEmail, sessionPassword);
      updateData();
      setIsModalOpen(false);
      logUserAction(db, auth, "ADD_USER", newUser.user.uid, null, APP_VERSION);
      message.success(`Usuario ${values.name} fue creado`);
    } catch (error) {
      console.log(error);
    }
  };

  const handleConfirm = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      form.submit();
      setConfirmVisible(false);
      setConfirmLoading(false);
    }, 2000);
  };

  const handleCancel = () => {
    setConfirmVisible(false);
  };

  const mapCouriers = (res) => {
    return res.docs.map((ele) => ({
      key: ele.id,
      ...ele.data(),
    }));
  };

  useEffect(() => {
    if (!data) {
      getDocs(collection(db, "couriers")).then((res) => {
        setData(mapCouriers(res));
      })
    }
  }, [data]);

  return (
    <Modal
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      title="Informacion del usuario"
    >
      <Form
        name="basic"
        form={form}
        layout="vertical"
        onFinish={handleSignUp}
        autoComplete="off"
        requiredMark
      >
        <Row gutter={16}>
          <Col xs={24} sm={24} md={24} lg={12}>
            {/* name */}
            <Form.Item
              name="name"
              label="Nombre"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar un nombre",
                  type: "string",
                },
                {
                  validator: validateFullName,
                },
              ]}
            >
              <Input placeholder="Nombre" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12}>
            {/* surname */}
            <Form.Item
              name="surname"
              label="Apellido"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar un apellido",
                  type: "string",
                },
                {
                  validator: validateFullName,
                },
              ]}
            >
              <Input placeholder="Apellido" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} sm={24} md={24} lg={12}>
            {/* email */}
            <Form.Item
              name="email"
              label="Email"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar un email",
                  type: "email",
                },
              ]}
            >
              <Input placeholder="Email" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12}>
            {/* phone number */}
            <Form.Item
              name="phone"
              label="Telefono"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar un numero telefonico",
                  type: "string",
                },
                {
                  validator: validatePhone,
                },
              ]}
            >
              <Input placeholder="Numero Telefonico" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} sm={24} md={24} lg={12}>
            {/* password */}
            <Form.Item
              label="Contraseña"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar una contraseña",
                },
                {
                  validator: validatePassword,
                },
              ]}
            >
              <Input.Password placeholder="Contraseña" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12}>
            {/* Role */}
            <Form.Item
              name="role"
              label="Rol"
              rules={[
                {
                  required: true,
                  message: "Campo requerido",
                },
              ]}
            >
              <Select placeholder="Seleccione una opcion" onChange={handleRoleChange}>
                {Object.values(roles).map((role, index) => <Option key={index} value={role}>{role}</Option>)}
              </Select>
            </Form.Item>
            {isCourier && (
              <Row gutter={16}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item
                    name="courierAssociation"
                    label="Courier Asociado"
                    rules={[
                      {
                        required: true,
                        message: "Debe seleccionar el courier asociado",
                      },
                    ]}
                  >
                    <Select placeholder="Seleccione un Courier">
                      {data && data.map(courier => (
                        <Option key={courier.key} value={courier.name}>{courier.name}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} sm={24} md={24} lg={12}>
            {/* password */}
            <Form.Item
              label="Direccion"
              name="andress"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar una direccion",
                },
                {
                  // validator: validatePassword,
                },
              ]}
            >
              <Input placeholder="Direccion" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12}>
            {/* Gender */}
            <Form.Item
              name="gender"
              label="Genero"
              rules={[
                {
                  required: true,
                  message: "Campo requerido",
                },
              ]}
            >
              <Select placeholder="Seleccione una opcion">
                {Object.values(genders).map((gender, index) => <Option key={index} value={gender}>{gender}</Option>)}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} sm={24} md={24} lg={12}>
            {/* password */}
            <Form.Item
              label="Usuario"
              name="user"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar un nombre de usuario",
                },
                {
                  // validator: validatePassword,
                },
              ]}
            >
              <Input placeholder="Usuario" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12}>
            {/* Role */}
            <Form.Item
              name="district"
              label="Distrito"
              rules={[
                {
                  required: true,
                  message: "Campo requerido",
                },
              ]}
            >
              <Input type="number" placeholder="Codigo de distrtito" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item className="footer-btn-modal">
          <Button onClick={() => setIsModalOpen(false)} size="large" className="btnCancel">
            Cancelar
          </Button>
          <Popconfirm
            title="Crear Usuario ?"
            open={confirmVisible}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
            okButtonProps={{
              loading: confirmLoading,
            }}
            okText="Si"
            cancelText="No"
          >
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              className="btnOK button-right"
              onClick={() => setConfirmVisible(true)}
            >
              Registrar
            </Button>
          </Popconfirm>
        </Form.Item>
      </Form>
    </Modal>
  );
};
